module.exports = __webpack_public_path__ + "static/footer-bg-26fab67f3bc7e627b038d0f2eadecc67.png";